import React from "react";
import { Link, useLocation } from "react-router-dom";

const Footer = () => {
  const year = new Date().getFullYear();

  const navLinks = [
    { name: "Home", path: "/" },
    { name: "Services", path: "/services" },
    { name: "Projects", path: "/projects" },
    { name: "Contact", path: "/contact" },
  ];

  const location = useLocation();

  return (
    <footer className="border-t border-gray-200 dark:border-gray-800 bg-white/95 dark:bg-gray-950/95 backdrop-blur-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 md:py-12">
        <div className="flex flex-col gap-10 md:grid md:grid-cols-12 md:items-start">
          {/* Brand + Mission */}
          <div className="md:col-span-5 flex flex-col gap-4">
            <div className="flex items-center gap-3">
              <div className="bg-black dark:bg-white rounded-2xl p-2.5 flex items-center justify-center">
                <img
                  src="https://universal-service.sfo3.cdn.digitaloceanspaces.com/logo/projectlockicon.PNG"
                  alt="Project Lock logo"
                  className="h-10 w-auto object-contain"
                  loading="lazy"
                />
              </div>
              <div className="flex flex-col">
                <span className="font-semibold text-base md:text-lg tracking-tight text-gray-900 dark:text-white">
                  Project Lock
                </span>
                <span className="text-[0.65rem] uppercase tracking-[0.22em] text-gray-500 dark:text-gray-400">
                  Inspect · Diagnose · Solve
                </span>
              </div>
            </div>

            <p className="text-sm md:text-base text-gray-600 dark:text-gray-400 max-w-md leading-relaxed">
              TriShield brings together waterproofing, structural protection, power
              resilience, and access automation into one engineered system, so your
              spaces stay safe, efficient, and future-ready.
            </p>
          </div>

          {/* Navigation */}
          <div className="md:col-span-3 flex flex-col gap-4">
            <h3 className="text-sm font-semibold tracking-wide text-gray-900 dark:text-white">
              Explore
            </h3>
            <nav className="flex flex-wrap md:flex-col gap-3 text-sm">
              {navLinks.map((link) => (
                <Link
                  key={link.name}
                  to={link.path}
                  className="text-gray-600 dark:text-gray-400 hover:text-black dark:hover:text-white transition-colors"
                >
                  {link.name}
                </Link>
              ))}
            </nav>
          </div>

          {/* Contact */}
          <div className="md:col-span-4 flex flex-col gap-4">
            <h3 className="text-sm font-semibold tracking-wide text-gray-900 dark:text-white">
              Contact
            </h3>

            <p className="text-sm text-gray-600 dark:text-gray-400 leading-relaxed">
              PROJECT LOCK
              <br />
              39/2475-B1, Suite J80,
              <br />
              LR Towers, SJRRA 104,
              <br />
              South Janatha Road, Palarivattom,
              <br />
              Kochi, Kerala 682025
            </p>

            <a
              href="mailto:info@project-lock.com"
              className="inline-flex items-center text-sm text-gray-700 dark:text-gray-300 hover:text-black dark:hover:text-white hover:underline underline-offset-2 transition-colors"
            >
              info@project-lock.com
            </a>
            {location.pathname !== "/contact" && (
              <Link
                to="/contact"
                className="inline-flex items-center justify-center mt-1 w-full sm:w-auto px-4 py-2 rounded-full border border-gray-300 dark:border-gray-700 text-sm font-medium text-gray-900 dark:text-white hover:bg-gray-100 dark:hover:bg-gray-900 transition-colors"
              >
                Talk to our team
              </Link>
            )}
          </div>
        </div>

        <div className="mt-10 flex flex-col md:flex-row items-center justify-between gap-4 border-t border-gray-100 dark:border-gray-800 pt-6">
          <p className="text-xs md:text-sm text-gray-500 dark:text-gray-500 text-center md:text-left">
            © {year} Project Lock. All rights reserved.
          </p>
          <p className="text-xs text-gray-400 dark:text-gray-500 text-center md:text-left max-w-md">
            Built with an engineering-first approach to safety, reliability, and
            longevity for every structure we safeguard.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

